module.exports = __webpack_public_path__ + "static/media/rest.5f9fbd09.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/connections-panel/connection-creator/rest.png
// module id = 114
// module chunks = 0